(function () {
  var STORAGE_KEY = 'cc_cart_market_switch';
  var TTL_MS = 5 * 60 * 1000;
  var LOG = '[CC-CART]';

  function saveCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) {
          var entry = { id: i.variant_id, quantity: i.quantity };
          if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) {
            entry.selling_plan = i.selling_plan_allocation.selling_plan.id;
          }
          if (i.properties && Object.keys(i.properties).length) {
            entry.properties = i.properties;
          }
          return entry;
        });
        console.log(LOG, 'saveCart:', items.length, 'items');
        var payload = { ts: Date.now(), items: items };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        return payload;
      });
  }

  function hookForm(formId) {
    var form = document.getElementById(formId);
    if (!form) return;
    var nativeSubmit = HTMLFormElement.prototype.submit;
    form.submit = function () {
      var f = this;
      saveCart().then(function (payload) {
        if (payload && payload.items && payload.items.length) {
          var returnTo = f.querySelector('[name=return_to]');
          if (returnTo) {
            var sep = returnTo.value.indexOf('?') >= 0 ? '&' : '?';
            returnTo.value = returnTo.value + sep + 'cc_cart=' + encodeURIComponent(JSON.stringify(payload));
            console.log(LOG, 'return_to →', returnTo.value.slice(0, 80) + '…');
          } else {
            console.warn(LOG, 'return_to input not found in', formId);
          }
        } else {
          console.log(LOG, 'cart empty, submitting without cc_cart');
        }
        nativeSubmit.call(f);
      }).catch(function (err) {
        console.warn(LOG, 'saveCart error:', err);
        nativeSubmit.call(f);
      });
    };
    console.log(LOG, 'hooked:', formId);
  }

  hookForm('desktop-market-form');
  hookForm('mobile-market-form');

  document.addEventListener('DOMContentLoaded', function () {
    var raw = sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      var params = new URLSearchParams(window.location.search);
      raw = params.get('cc_cart');
      if (raw) {
        console.log(LOG, 'found cc_cart in URL, restoring…');
        params.delete('cc_cart');
        var cleanUrl = window.location.pathname +
          (params.toString() ? '?' + params.toString() : '') +
          window.location.hash;
        window.history.replaceState({}, '', cleanUrl);
      } else {
        console.log(LOG, 'no cc_cart in URL or sessionStorage');
      }
    } else {
      console.log(LOG, 'found cc_cart in sessionStorage, restoring…');
      sessionStorage.removeItem(STORAGE_KEY);
    }

    if (!raw) return;

    var data;
    try { data = JSON.parse(raw); } catch (e) { console.warn(LOG, 'JSON parse error:', e); return; }
    if (!data || !data.items || !data.items.length) { console.log(LOG, 'payload has no items'); return; }
    if (Date.now() - data.ts > TTL_MS) { console.warn(LOG, 'payload expired'); return; }

    console.log(LOG, 'clearing destination cart before restore…');

    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url)
      ? window.theme.routes.cart_add_url
      : '/cart/add.js';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        console.log(LOG, 'cart cleared — adding', data.items.length, 'item(s)…');
        return data.items.reduce(function (chain, item) {
          return chain.then(function () {
            return fetch(cartUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(item)
            }).then(function (r) {
              if (!r.ok) {
                return r.json().then(function (err) {
                  console.warn(LOG, 'add failed for variant', item.id, '—', err.description || err.message || r.status);
                });
              }
              console.log(LOG, 'added variant', item.id);
            }).catch(function (err) {
              console.warn(LOG, 'network error adding variant', item.id, err);
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        console.log(LOG, 'restore complete — reloading page');
        document.dispatchEvent(new CustomEvent('cart:restored'));
        window.location.reload();
      })
      .catch(function (err) {
        console.warn(LOG, 'cart clear failed:', err);
      });
  });
})();
